import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';
import { BasePrimaryText } from '../common.styles';

export const RoleContainer = styled(Box).attrs({
  width: '100%',
  bg: 'background',
  height: 'auto',
  my: 10,
})`
  position: relative;
`;
export const RoleHeader = styled(Box).attrs({
  bg: 'background',
  p: 15,
  horizontal: true,
  justify: 'space-between',
})`
  border: ${p => `1px solid ${p.theme.colors.heavyLineOutline}`};
`;

export const AccordionRow = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  padding: '15px 0',
})``;

export const AccordionRowText = styled(BasePrimaryText)`
  flex: 1 1 auto;
`;

export const AccordionSectionTitle = styled(Text).attrs({
  fontWeight: 'semibold',
  color: 'primaryText',
  size: 'small',
})``;

export const AccordionSectionDesc = styled(Text).attrs({
  color: 'primaryText',
  size: 'small',
})``;
